import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { AppContext } from '../../context/AppContext';
import { PhoneNumberInput } from '../Input';
import Button from '../Button';
import { formatPhoneNumberToSend } from '../../util/PhoneNumber';
import { SEARCH_TYPES } from '../../util/customersUtil';
import useMutateAnalytics from '../../util/mutate.Analytics';
import analyticsKeys from '../../util/UsageStatLinks';

const Form = styled.form`
  padding: 20px 15px;
`;

export default function SearchModal({
  close,
  referrers,
  setSearchQuery,
  setContactsCategory,
}) {
  const { app } = useContext(AppContext);
  const [phoneNumber, setPhoneNumber] = useState('');
  const mutateAnalytics = useMutateAnalytics();

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        setContactsCategory(null);
        const mutateAnalyticsVariables = {
          link: analyticsKeys.CONTACTS_SEARCH,
        };
        mutateAnalytics(mutateAnalyticsVariables);
        if (referrers?.length > 0) {
          setSearchQuery({
            phoneNumber: formatPhoneNumberToSend(phoneNumber),
            type: SEARCH_TYPES.RefContacts,
          });
        } else if (app.getMetricesQuery) {
          setSearchQuery({
            phoneNumber: formatPhoneNumberToSend(phoneNumber),
            type: SEARCH_TYPES.MetricesContacts,
          });
        } else {
          setSearchQuery({ phoneNumber, type: SEARCH_TYPES.AllContacts });
        }

        close();
      }}
    >
      <PhoneNumberInput
        top
        type="tel"
        header="PHONE NUMBER"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        width="calc(100%)"
        required
      />
      <Button
        margin="80px 0px 0px 0px"
        text="SEARCH CONTACTS"
        type="submit"
        width="100%"
        // loading={loading}
      />
    </Form>
  );
}
